const HeroHeader = () => {
  const component = document.querySelector('.js-heroHeader-search');
  const forms = document.querySelectorAll('.js-heroHeader-searchPaneVn, .js-heroHeader-searchPaneVo');

  if (component) {
    const tabs = [...component.querySelectorAll('.js-heroHeader-searchTab')];
    const panes = [...component.querySelectorAll('.js-heroHeader-searchPane')];

    for (const tab of tabs) {
      const idx = tabs.indexOf(tab);
      const pane = panes[idx];
      const handler = () => {
        for (const t of tabs) {
          if (t === tab) {
            t.classList.add('-primary');
            t.classList.remove('-bo');
          } else {
            t.classList.add('-bo');
            t.classList.remove('-primary');
          }
        }

        for (const p of panes) {
          if (p === pane) {
            p.classList.add('-active');
          } else {
            p.classList.remove('-active');
          }
        }
      };

      tab.addEventListener('click', handler);
    }
  }

  for (const form of forms) {
    const submitHandler = (e) => {
      const route = form.elements['route'];
      const params = [];

      if (form.elements['route']) {
        form.elements['route'].setAttribute('disabled', 'disabled');
      }

      for (const temp of form.querySelectorAll('.-temp')) {
        temp.remove();
      }

      for (const { name, value } of form.querySelectorAll('input')) {
        if (value && name !== 'route') {
          params.push({ name, value });
        }
      }

      params.sort((a, b) => a.name.localeCompare(b.name));

      for (const { name, value } of params) {
        const input = document.createElement('input');

        input.classList.add('-temp');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.append(input);
      }

      if (route?.value) {
        form.action = route.value;
      }

      return true;
    };

    form.addEventListener('submit', submitHandler);
  }
};

export default HeroHeader;
